export default "__VITE_ASSET__ClvdFPZE__"